import { generateId } from '@freelancer/datastore/testing/helpers';
import { SwiftIdInvitationStatus } from './swift-id-invitation.model';
import type { SwiftIdInvitation } from './swift-id-invitation.model';

/**
 * Options for generating a SwiftID invitation
 */
export interface GenerateSwiftIdInvitationOptions {
  readonly id?: number;
  readonly applicationId?: number;
  readonly userId?: number;
  readonly invitedBy?: number;
  readonly status?: SwiftIdInvitationStatus;
  readonly createdAt?: number;
  readonly updatedAt?: number;
  readonly applicantId?: number;
}

/**
 * Generates a SwiftID invitation object
 */
export function generateSwiftIdInvitationObject({
  id = generateId(),
  applicationId = generateId(),
  userId = generateId(),
  invitedBy = generateId(),
  status = SwiftIdInvitationStatus.PENDING,
  createdAt = Date.now(),
  updatedAt = Date.now(),
  applicantId = undefined,
}: GenerateSwiftIdInvitationOptions = {}): SwiftIdInvitation {
  return {
    id,
    applicationId,
    userId,
    invitedBy,
    status,
    createdAt,
    updatedAt,
    applicantId,
  };
}

export function generateSwiftIdInvitationObjects(
  count: number,
  options: GenerateSwiftIdInvitationOptions = {},
): readonly SwiftIdInvitation[] {
  return Array.from({ length: count }, () =>
    generateSwiftIdInvitationObject(options),
  );
}

export function generateSwiftIdAcceptedInvitation(
  options: GenerateSwiftIdInvitationOptions = {},
): SwiftIdInvitation {
  const baseInvitation = generateSwiftIdInvitationObject({
    ...options,
    status: SwiftIdInvitationStatus.ACCEPTED,
  });

  return {
    ...baseInvitation,
    updatedAt: baseInvitation.updatedAt + 1000,
  };
}
